// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp, { getServerSideProps as getSSP } from 'tenants/_template/desktop/[slug]'

  

  export const getServerSideProps = getSSP;
  export default PageOrApp;